import axios from 'axios';
import {PostMessageService, PostMessagesTypes} from "./postMessageService";
import {modal} from "../../utils/pixiApp";
import {ErrorModalComponent} from "../../components/modals/ErrorModalComponent";
import {ErrorBalanceModalComponent} from "../../components/modals/ErrorBalanceModalComponent";

export const checkTokenInterceptor = () => {
    const awaitPostMessage = function() {
        return new Promise((resolve) => {
            const messageHandlerForPromise = (eventHasJSON) => {
                const event = typeof eventHasJSON?.data === 'string'
                        ? JSON.parse(eventHasJSON.data)
                        : eventHasJSON;
                window.removeEventListener('message', messageHandlerForPromise, false);
                return resolve(event.data);
            }
            window.addEventListener('message', messageHandlerForPromise, false);
            PostMessageService.postMessage({
                type: PostMessagesTypes.REFRESH_TOKEN,
            });
        });
    };

  axios.interceptors.response.use(
    (res) => res,
    async (err) => {
        if (!err.response) return Promise.reject(err);
        const {
            status,
            config,
            data: {message, error, errors},
        } = err.response;

        console.log(errors[0].errorCode === "MONEY_NOT_ENOUGH")

        if ((status === 401 && error && error.includes('Unauthorized')) || (errors && errors[0].errorCode === "SESSION_EXPIRED") || errors && errors[0].errorCode === 'ACCESS_DENIED') {
            sessionStorage.removeItem('access_token');
            const token = await awaitPostMessage();
            if(!token) {
                modal.onEmitIsOpenEvent(true, new ErrorModalComponent)
                return
                // return Promise.reject(err)
            }
            let headers;
            headers = {...config.headers, ...{ Authorization: `${token}` }}
            if (typeof token === "string") {
                sessionStorage.setItem('access_token', token);
            }
            return axios.request({...config, ...{headers: headers}});
        }
        if(errors && errors[0].errorCode === "MONEY_NOT_ENOUGH") {
            modal.onEmitIsOpenEvent(true, new ErrorBalanceModalComponent)
            return
        }

        modal.onEmitIsOpenEvent(true, new ErrorModalComponent)
    }
      );
  }
